import { Link, useLocation } from "wouter";
import { useAuth } from "../lib/auth";

export default function Header() {
  const [location] = useLocation();
  const { isAdmin } = useAuth();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass border-b border-stone-200/50">
      <div className="container py-3 sm:py-4">
        <div className="flex items-center justify-between">
          {/* Logo - コンパクトにモバイル対応 */}
          <Link href="/">
            <div className="flex items-center gap-2 sm:gap-3 cursor-pointer group shrink-0">
              <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg sm:rounded-xl bg-gradient-to-br from-teal-500 to-emerald-500 flex items-center justify-center">
                <svg
                  className="h-4 w-4 sm:h-5 sm:w-5 text-white"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  viewBox="0 0 24 24"
                >
                  <circle cx="7" cy="20" r="2" />
                  <circle cx="17" cy="20" r="2" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17 18H7V9a4 4 0 014-4h2a4 4 0 014 4v3" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 9h14" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l2-4" />
                </svg>
              </div>
              <div>
                <h1 className="text-sm sm:text-lg font-semibold text-stone-900 tracking-tight">
                  SONOMAMA
                </h1>
                <p className="text-xs text-stone-500 hidden md:block">ベビーカーで、そのまま。</p>
              </div>
            </div>
          </Link>

          {/* Navigation - モバイル最適化 */}
          <nav className="flex items-center gap-1 sm:gap-2 md:gap-4">
            <NavLink href="/stores" active={location.startsWith("/stores")}>
              <span className="hidden sm:inline">店舗検索</span>
              <span className="sm:hidden">店舗</span>
            </NavLink>
            <NavLink href="/articles" active={location.startsWith("/articles")}>
              <span className="hidden md:inline">おでかけ</span>コラム
            </NavLink>
            {isAdmin && (
              <NavLink href="/admin" active={location.startsWith("/admin")}>
                管理
              </NavLink>
            )}
          </nav>
        </div>
      </div>
    </header>
  );
}

function NavLink({
  href,
  active,
  children,
}: {
  href: string;
  active: boolean;
  children: React.ReactNode;
}) {
  return (
    <Link
      href={href}
      className={`text-xs sm:text-sm font-medium transition-colors px-2 sm:px-3 py-1.5 sm:py-2 rounded-md sm:rounded-lg whitespace-nowrap ${
        active
          ? "text-teal-600 bg-teal-50"
          : "text-stone-600 hover:text-stone-900 hover:bg-stone-100"
      }`}
    >
      {children}
    </Link>
  );
}
